import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AddressBookService } from 'modules/crm/address-book/services';
import { ADDRESS_BOOKS_LIST_KEY } from 'modules/crm/address-book/constants';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useDeleteAddressBook = (id: string, onClose: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('addressBook');
  return useMutation(() => AddressBookService.delete(id), {
    onSuccess: (data) => {
      toast.success(t('successDeleted'));
      onClose?.();
      queryClient.invalidateQueries({ queryKey: [ADDRESS_BOOKS_LIST_KEY] });
      queryClient.invalidateQueries({ queryKey: [id] });
    },
  });
};
